import { IHubConnection, ISignalRError } from '../interfaces/signal.interface';

export function isSignalRError(res: any): res is ISignalRError {
  return res && typeof res.message === 'string';
}

export function isHubConnection(res: any): res is IHubConnection {
  return res && typeof res.id === 'string';
}


// WEBPACK FOOTER //
// ./src/app/core/signalr-type-guards.ts/signalr-type-guards.ts